import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import useTranslation from 'next-translate/useTranslation'
import dynamic from 'next/dynamic'
import { useQuery } from '@apollo/client'
import styles from './style.module.scss'

import { HOT_STORIES, TRENDING_NEWS } from '@graphql/home/home.query'
import Slider from '../slider'
import useWindowSize from '@shared/hooks/windowSize'
import { GET_SEO_DATA } from '@graphql/article/article.query'

const Skeleton = dynamic(() => import('@shared/components/skeleton'), { ssr: false })
const TrendingNewsList = dynamic(() => import('./trendingNewsList'), {
  loading: () => loader
})

const loader = (
  <>
    {Array.from(Array(3)).map((e, i) => {
      return (
        <div className="my-3 d-flex" key={i}>
          <div>
            <Skeleton height={'60px'} width={'96px '} />
          </div>
          <div className="w-100 ps-2">
            <Skeleton height={'40px'} className={'mb-2'} />
            <div height={'14px'} className="d-flex">
              <Skeleton width={'20%'} height={'14px'} className={'me-2'} />
              <Skeleton width={'20%'} height={'14px'} className={'me-3'} />
            </div>
          </div>
        </div>
      )
    })}
  </>
)

function TrendingNewsArticle({ isSlider, ePlatform = '', isTennis = false }) {
  const [width] = useWindowSize()
  const { t } = useTranslation()
  // const [scrollCount, setScrollCount] = useState(1)
  const countRef = useRef({})
  const { data, loading } = useQuery(TRENDING_NEWS, {
    variables: { input: { nSkip: 0, nLimit: 4 } },
    onCompleted: () => {
      if (countRef.current && isSlider) {
        countRef.current.innerText = 1 + ' / ' + data?.getTrendingNews?.aResults.length
      }
    },
    skip: isTennis
  })

  const { data: seoData } = useQuery(GET_SEO_DATA, {
    variables: { input: { sSlug: 'tennis-news' } },
    skip: !isTennis
  })
  const { data: hotStories, loading: hotStoriesLoading } = useQuery(HOT_STORIES, {
    variables: {
      input: {
        iCategoryId: seoData?.getSeoData?.iId,
        eType: 'n',
        nLimit: 5
      }
    },
    skip: !isTennis
  })

  useEffect(() => {
    const slider = document.getElementById('c-slider')
    slider?.addEventListener('scroll', e => {
      const number = parseInt((e.target?.scrollLeft - 15) / e?.target?.offsetWidth) + 1
      countRef.current.innerText = number + ' / ' + data?.getTrendingNews?.aResults.length
      // setScrollCount(number)
    })
  }, [data?.getTrendingNews?.aResults.length, width])

  const dataToMap = isTennis ? hotStories?.listSimpleCategoryArticlesVideosFront?.oArticles?.aResults : data?.getTrendingNews?.aResults

  return (
    <>
      {dataToMap !== 0 && (
        <div className="widget">
          {width < 992 && isSlider && (
            <>
              <h3 className={`${styles.headingTitle} small-head d-flex justify-content-between align-items-center mb-4`}>
                <span className={styles.title}>{t('common:featuredNews')}</span>
                <span ref={countRef} className={styles.counter}></span>
              </h3>
              <Slider destroyBelow={1199} single>
                <TrendingNewsList data={dataToMap} />
              </Slider>
            </>
          )}
          {width > 992 && !isSlider && (
            <>
              <h3 className="small-head d-flex align-items-center mb-3">{t('common:featuredNews')}</h3>
              <div className={styles.trendingList}>
                <TrendingNewsList data={dataToMap} ePlatform={ePlatform} />
              </div>
            </>
          )}

          {loading && loader && hotStoriesLoading}
        </div>
      )}
    </>
  )
}
TrendingNewsArticle.propTypes = {
  isSlider: PropTypes.bool,
  ePlatform: PropTypes.string,
  isTennis: PropTypes.bool
}
export default TrendingNewsArticle
